import type { TFunction } from 'i18next'

import { komaEndTime, komaNumberToTime } from '~/models/komaToTime'

/**
 * コマ番号と時間帯を併記するラベル (AC-BSP-004c のコマ表記) を作る唯一の入口。
 * 書式・区切り (ja `〜` / en `-`、英語付録) は `common:komaLabel.*` の文言 1 組だけが持ち、
 * 呼び出し側は key も補間名も知らない。 番号はゼロ埋めせず、 コマ 48 の終了は "24:00"
 * ([[komaEndTime]])。
 */
const interpolation = (
  koma: number,
): { koma: number; start: string; end: string } => {
  const start = komaNumberToTime(koma)
  return { koma, start, end: komaEndTime(start) }
}

/** 標準形「コマ 28 (13:30〜14:00)」 / 「Slot 28 (13:30-14:00)」。 */
export const formatKomaLabel = (t: TFunction, koma: number): string =>
  t('common:komaLabel.standard', interpolation(koma))

/**
 * compact 形「28 (13:30〜14:00)」 / 「28 (13:30-14:00)」。 項目ラベルに「コマ」 が
 * 既出の箇所 (板発注のコマ情報パネル見出し AC-BIN-026b 等) が使う。
 */
export const formatKomaCompactLabel = (t: TFunction, koma: number): string =>
  t('common:komaLabel.compact', interpolation(koma))

/**
 * 範囲形「コマ 13〜16 (06:00〜08:00)」 / 「Slots 13-16 (06:00-08:00)」。 ブロック入札 CSV の
 * Step2 プレビューが使う (spot-bid-block-csv-import.md §6 の Step2 のコマ表示)。 終了時刻は最終コマの終了
 */
export const formatKomaRangeLabel = (
  t: TFunction,
  startKoma: number,
  endKoma: number,
): string =>
  t('common:komaLabel.range', {
    startKoma,
    endKoma,
    start: komaNumberToTime(startKoma),
    end: komaEndTime(komaNumberToTime(endKoma)),
  })
